/**
 * useTherapyStyles Hook
 *
 * React Query hook for fetching available therapy styles.
 * Caches styles for efficient re-use across settings and reflection pages.
 */

import { useQuery } from "@tanstack/react-query";
import { listTherapyStyles } from "../services/therapyStylesService";
import type { TherapyStyleResponse } from "../types/therapy-style";

/**
 * Hook to fetch all active therapy styles
 *
 * Styles are cached for 10 minutes as they rarely change.
 */
export function useTherapyStyles() {
  return useQuery<TherapyStyleResponse[], Error>({
    queryKey: ["therapyStyles"],
    queryFn: listTherapyStyles,
    staleTime: 10 * 60 * 1000,
  });
}
